var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInteraction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.821,
    height: 13.821,
    viewBox: "0 0 13.821 13.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download_3_",
    "data-name": "download (3)",
    d: "M191.806,178.68h-9.674a.691.691,0,0,0-.691.691v2.073h-2.073a.691.691,0,0,0-.691.691v9.674a.691.691,0,0,0,.691.691h9.674a.691.691,0,0,0,.691-.691v-2.073h2.073a.691.691,0,0,0,.691-.691v-9.674a.691.691,0,0,0-.691-.691Zm-3.455,12.439h-8.292v-8.292h1.382v6.219a.691.691,0,0,0,.691.691h6.219Zm2.764-2.764h-8.292v-8.292h8.292Zm-6.219-6.219a.691.691,0,0,1,.691-.691h3.455a.691.691,0,0,1,.691.691v3.455h0a.691.691,0,1,1-1.382,0v-2.764h-2.764a.691.691,0,0,1-.691-.691Z",
    transform: "translate(-178.677 -178.68)",
    fill: "#256f92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteraction);
export default __webpack_public_path__ + "static/media/interaction.c1c44d67e784ac8b4c16bef057eea954.svg";
export { ForwardRef as ReactComponent };